import api from '../config/axios'; // Using the configured axios instance

interface SendDirectMessageRequest {
  receiver_id: number;
  content: string;
  message_type: 'text' | 'image' | 'audio' | 'video' | 'document';
}

interface MessageResponse {
  id: number;
  sender_id: number;
  receiver_id: number;
  content: string;
  message_type: string;
  timestamp: string;
  read: boolean;
  // Add other fields as per your backend response
}

class MessageService {
  async sendDirectMessage(request: SendDirectMessageRequest): Promise<MessageResponse> {
    const maxRetries = 3;
    let lastError: any;

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      try {
        // The api instance already has baseURL configured in config/axios.ts
        // So we just need '/messages/send-direct' to get the full path
        const response = await api.post<MessageResponse>('/messages/send-direct', request);
        return response.data;
      } catch (error: any) {
        lastError = error;
        
        // Check if it's a duplicate key error
        if (error.response?.data?.message?.includes('duplicate key value violates unique constraint')) {
          if (attempt < maxRetries - 1) {
            // Wait with exponential backoff before retrying
            const delay = Math.pow(2, attempt) * 1000; // 1s, 2s, 4s
            console.warn(`Duplicate message ID detected, retrying in ${delay}ms...`);
            await new Promise(resolve => setTimeout(resolve, delay));
            continue;
          }
        }
        
        console.error(`Error sending direct message (attempt ${attempt + 1}):`, error);
        
        // If it's the last attempt or not a duplicate key error, throw immediately
        if (attempt === maxRetries - 1 || !error.response?.data?.message?.includes('duplicate key value violates unique constraint')) {
          break;
        }
      }
    }
    
    throw new Error(lastError?.response?.data?.message || 'Failed to send direct message after retries');
  }

  // You can add other message-related methods here (e.g., getConversation, markAsRead)
}

const messageService = new MessageService();
export default messageService;